import { Component, Input, OnInit } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from 'ionic-angular';
@Component({
  selector: 'sts-job-share',
  templateUrl: 'job-share.component.html'
})
export class JobShareComponent implements OnInit {
    @Input() jobId = 0;
    jobPath = '';
    quote : any;
    twitterURL = 'https://twitter.com/intent/tweet?';
    facebookURL = 'http://www.facebook.com/sharer/sharer.php?';
    linkedinURL = 'http://www.linkedin.com/shareArticle?';
    mailURL = 'mailto:?';
    smsURL = "sms:";

    constructor(private locationStrategy: LocationStrategy, private translate: TranslateService, private platform: Platform) {
        this.translate.get(['CAREER_JOB_SHARE_MESSAGE']).subscribe((obj) => {
      this.quote = obj;
    });
    }

    

    ngOnInit() {
        this.linkify();
    }

    public shareVia(share) {
        const searchParams: URLSearchParams = new URLSearchParams();
        switch (share) {
            case 'mail': {
                window.open(this.mailURL + 'subject=' + this.quote.CAREER_JOB_SHARE_MESSAGE + '&body=' + this.jobPath, "_system");
                break;
            }
            case 'sms': {
                if(this.platform.is('ios')) {
                    this.smsURL += '&'; 
                } else {
                    this.smsURL += '?';
                }
                searchParams.set(';', '');
                searchParams.set('body', this.jobPath);
                window.open(this.smsURL + searchParams, "_system");
                break;
            }
            case 'linkedin': {
                searchParams.set('url', this.jobPath);
                searchParams.set('summary', this.quote.CAREER_JOB_SHARE_MESSAGE);
                searchParams.set('title', 'Job');
                window.open(this.linkedinURL + searchParams, "_system");
                break;
            }
            case 'twitter': {
                searchParams.set('url', this.jobPath);
                window.open(this.twitterURL + searchParams, "_system");
                break;
            }
            case 'facebook': {
                searchParams.set('u', this.jobPath);
                window.open(this.facebookURL + searchParams, "_system");
                break;
            }
            default: {
                searchParams.set('subject', this.quote.CAREER_JOB_SHARE_MESSAGE);
                searchParams.set('body', this.jobPath);
                window.open(this.mailURL + searchParams, "_system");
                break;
            }
        }
    }

    private linkify() {
        const path = window.location.href;
        this.jobPath = `${path.replace(window.location.hash,'')}#/job/${this.jobId}`; 
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/job-search/components/job-share/job-share.component.ts